import { UAParser } from 'ua-parser-js'

// These values were defined by the search team (Ad Team)
// They are defined to give visibility into where queries
// are being initiated from
//
// DesktopWebSearch | 1
// MobileWebSearch | 2
// MobileAppSearch | 3
// DesktopWebBrowse | 4
// MobileWebBrowse | 5
// MobileAppBrowse | 6

enum SearchSection {
  search = 'search',
  browse = 'browse',
}

export const getSectionId = (isBrowsing: boolean) => {
  if (isBrowsing) {
    return getSearchSection(SearchSection.browse)
  } else {
    return getSearchSection(SearchSection.search)
  }
}

const getSearchSection = (section: string) => {
  const uaParser = new UAParser()
  const isMobile = uaParser.getDevice().type === 'mobile'
  const isSearching = SearchSection.search === section
  const isBrowsing = SearchSection.browse === section

  if (isMobile && isSearching) {
    return 2
  } else if (isMobile && isBrowsing) {
    return 5
  } else if (isSearching) {
    return 1
  } else if (isBrowsing) {
    return 4
  }

  return -1
}
